export default __webpack_public_path__ + "static/media/Resume.fe2c3be0.pdf";